import { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import instance, { CRM_REPORT_API_URL } from 'api';
import { IPartnerRatingByPartnerUgo, IRealEstateRatingByPartnerUgo } from '../../interfaces';
import { IApplicationByPartnerUgo, INomenclature } from './interfaces';

export const getPartnerRatingByPartnerUgo = async (partnerGuid: string, config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IPartnerRatingByPartnerUgo>(`/partner/rating/listByPartnerUgo/${partnerGuid}`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getPartnersRatingByPartnerUgo = async (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: IPartnerRatingByPartnerUgo[]; totalCount: number }>('/partner/rating/listByPartnerUgo', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getPartnerRatingUgoByRealEstate = async (
  partnerGuid: string,
  realEstateGuid: string,
  config?: AxiosRequestConfig,
) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IRealEstateRatingByPartnerUgo[]>(`/partner/rating/listByPartnerUgo/${partnerGuid}/${realEstateGuid}`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getApplicationsByPartnerUgo = async (
  partnerGuid: string,
  realEstateGuid: string,
  config?: AxiosRequestConfig,
) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IApplicationByPartnerUgo[]>(`/partner/rating/listApplicationsByPartnerUgo/${partnerGuid}/${realEstateGuid}`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const exportPartnerRatingByPartnerUgoExcel = async (partnerGuid: string, config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/partner/rating/listByPartnerUgo/${partnerGuid}/export`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
      responseType: 'blob',
    })
    .then((response) => response.data);
};

export const exportPartnerRatingUgoByRealEstateExcel = async (
  partnerGuid: string,
  realEstateGuid: string,
  config?: AxiosRequestConfig,
) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>(`/partner/rating/listByPartnerUgo/${partnerGuid}/${realEstateGuid}/export`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
      responseType: 'blob',
    })
    .then((response) => response.data);
};

export const exportAllPartnersRatingByPartnerUgoExcel = async (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>('/partner/rating/listByPartnerUgo/allNomenclaturaExport', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
      responseType: 'blob',
    })
    .then((response) => response.data);
};

export const getNomenclatureList = () => {
  return instance(true, CRM_REPORT_API_URL)
    .get<INomenclature[]>(`/partner/rating/listAllNomenclatura`)
    .then((response) => response.data);
};
